export default __webpack_public_path__ + "static/media/icon_queue.04e9ca73.svg";